import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import InfoPic from "../../../../assets/images/info-img.png";
import { useSelector } from "react-redux";
import { SendSoundAlert } from "./SendSoundAlert";
import { findDevice } from "../../AxiosRtk/DeviceDetail";
import useFirebase from "../../../../useFirebase";

const FindTheDevice = ({ showModal, closeModal, getLangTranslation }) => {
  const { getDeviceStatus } = useFirebase();
  const [deviceStatusData, setDeviceStatus] = useState(null);
  const { kidList, selectedKidId, selectedDeviceData } = useSelector(
    ({ dashboard }) => dashboard
  );

  const kidData = kidList?.find(
    (item) => item?.ID === parseInt(selectedKidId)
  );

  const [showAlertModal, setShowAlertModal] = useState(false);
  const openAlertModal = () => {
    setShowAlertModal(true);
  };

  const closeAlertModal = () => {
    setShowAlertModal(false);
  };

  useEffect(() => {
    async function getDeviceStatusData(id) {
      const data = await getDeviceStatus(id);
      setDeviceStatus(data?.data?.deviceStatus);
    }

    if (selectedDeviceData) {
      getDeviceStatusData(selectedDeviceData?.ID);
    }
  }, [selectedDeviceData]);

  const handleAlert = async () => {
    try {
      const payload = {
        case: 7,
        deviceId: selectedDeviceData?.ID,
      };
      const { data } = await findDevice(payload);
      if (data) {
        closeModal();
        openAlertModal();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <Modal
        show={showModal}
        size="sm"
        className="custom-modal blur-bg"
        centered
      >
        <Modal.Header>
          <div className="border-0 pb-0 d-flex justify-content-between w-100">
            <h6 className="modal-title text-blue-900">
              {getLangTranslation(
                "DEVICE_SEND_SOUND_ALERT",
                "Send sound alert"
              )}
            </h6>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            ></button>
          </div>
        </Modal.Header>
        <Modal.Body className="py-1 px-4">
          <div className="modal-body">
            <img className="d-block mx-auto mt-6" src={InfoPic} alt="" />
            <h6 className="my-6 text-center text-blue-900">
              {getLangTranslation(
                "SEND_SOUND_ALERT_CHILD_DEVICE",
                "Send sound alert to the $CHILD_NAME$'s $DEVICE_NAME$"
              )
                ?.replace("$CHILD_NAME$", kidData?.childName)
                ?.replace("$DEVICE_NAME$", selectedDeviceData?.Name)}
            </h6>
            <div className="text-center mb-2">
              {getLangTranslation(
                "DEVICE_DETAIL_FIND_DEVICE_PRESS_BUTTON",
                "Press the button to sound an alert"
              )}
            </div>
            <div className="content-300 bg-blue-50 py-2 px-3 rounded-1 text-center mx-auto mb-9">
              <h6 className="text-blue-900 mb-0">
                {kidData?.childName}’s {selectedDeviceData?.DeviceType}{" "}
                {getLangTranslation(
                  "DEVICE_DETAIL_FIND_DEVICE_STATUS",
                  "status"
                )}{" "}
                -
                <span
                  className={`${
                    deviceStatusData === 1 ? "text-success" : "text-danger"
                  }`}
                >
                  {deviceStatusData === 1
                    ? ` ${getLangTranslation("CHILD_DETAIL_ONLINE", "Online")}`
                    : ` ${getLangTranslation(
                        "CHILD_DETAIL_ONLINE",
                        "Offline"
                      )}`}
                </span>
              </h6>
            </div>
            <div className="grid gap-3">
              <button
                className="btn btn-outline-primary g-col-6"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              >
                <span className="btn-upper-case">
                  {getLangTranslation("CANCEL", "Cancel")}
                </span>
              </button>
              <button className="btn btn-primary g-col-6" onClick={handleAlert}>
                <span className="btn-upper-case">
                  {getLangTranslation("PIN_CODE_RECOVERY_SEND", "SEND")}
                </span>
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <SendSoundAlert
        showModal={showAlertModal}
        closeModal={closeAlertModal}
        kidData={kidData}
      />
    </div>
  );
};

export default FindTheDevice;
